/**
 * created by wang lei
  模板 页面
 *
 */
import React, {Component} from 'react';
import template from './template.png';

export default class TemplateTool extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <span>
                <img src={template}/>
            </span>
        )
    }

}